module.exports = __webpack_public_path__ + "images/carrot-white.64e2f335.svg";